export const pdfItemFile = {
  icon: 'pdfFile',
  fileName: 'Contrato no 422 copy 2 final 3',
  uploadDate: 'Hace 2 hora',
};
export const docItemFile = {
  icon: 'docFile',
  fileName: 'Contrato no 422 copy 2 final 3',
  uploadDate: 'Hace 2 hora',
};